import React from 'react';

interface PermissionModalProps {
    requestPermission: () => void;
}

const PermissionModal: React.FC<PermissionModalProps> = ({ requestPermission }) => {

  const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  };

  const modalStyle: React.CSSProperties = {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '15px',
    width: '400px',
    maxWidth: '90%',
    textAlign: 'center',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
  };

  const buttonStyle = {
    backgroundColor: '#1E6091',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '20px',
    transition: 'background-color 0.3s ease'
  };

  return (
    <div>
      <div style={overlayStyle}>
        <div style={modalStyle}>
            <h1 style={{ marginBottom: '15px', color: '#333', fontSize: '24px' }}>
            Acceso a la cámara requerido
            </h1>
            <p style={{ color: '#666', lineHeight: '1.6', fontSize: '16px', textAlign: 'left' }}>
            Este permiso es necesario por regulación y para proteger tu identidad.
            </p>

            <p style={{ lineHeight: '1.6', fontSize: '14px', marginTop: '20px', textAlign: 'left', marginBottom: '10px' }}>
                Si no puedes continuar revisa la configuración de tu dispositivo.
            </p>
            <p style={{ lineHeight: '1.6', fontSize: '12px', textAlign: 'left', fontWeight: 'bold', marginLeft: '5px' }}>
                Iphone.
            </p>
            <p style={{ lineHeight: '1.6', fontSize: '12px', textAlign: 'left', marginLeft: '5px' }}>
                - Revisa los ajustes de privacidad de tu celular y vuelve a intentarlo. Asegurate que el navegador tenga acceso a la cámara y el modo Hermético (LockDown) este desactivado.
            </p>
            <p style={{ lineHeight: '1.6', fontSize: '12px', textAlign: 'left', marginLeft: '5px' }}>
                Ajustes &gt; Privacidad y Seguridad &gt; Modo Hermético.
            </p>
            <p style={{ lineHeight: '1.6', fontSize: '12px', textAlign: 'left', fontWeight: 'bold', marginLeft: '5px', marginTop: '10px' }}>
                Android.
            </p>
            <p style={{ lineHeight: '1.6', fontSize: '12px', textAlign: 'left', marginLeft: '5px' }}>
                - Revisa los ajustes de privacidad de tu celular y vuelve a intentarlo. Asegurate que el navegador tenga acceso a la cámara.
            </p>

          <div style={{ marginTop: '20px' }}>
            <button 
              onClick={requestPermission}
              style={buttonStyle}
              onMouseOver={(e) => (e.target as HTMLButtonElement).style.backgroundColor = '#2980b9'}
              onMouseOut={(e) => (e.target as HTMLButtonElement).style.backgroundColor = '#3498db'}
            >
              Dar acceso
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PermissionModal;